import(/* webpackMode: "eager" */ "/root/apps/restatic/frontend/src/app/error.tsx");
